module.exports = __webpack_public_path__ + "images/icon/icn_modechange_16x16-9ef205b3.svg";